export const useSearchNavigate = () => {
    const searchUrl = useSearchUrl();

    return function searchNavigate(query: string, manufacturerPath?: string) {
        return navigateTo(searchUrl(query, manufacturerPath));
    };
};
